import React from 'react';
import { StepProps } from '../MultiStepModal';

const TYPE_FIELDS: Record<string, { label: string; placeholder: string }[]> = {
  REPAIR:       [{ label: 'Issue description *', placeholder: 'Describe the fault or problem…' }, { label: 'Appliance / system type', placeholder: 'e.g. Combi boiler, radiator' }],
  INSPECTION:   [{ label: 'Compliance type', placeholder: 'e.g. Annual gas safety (CP12)' }, { label: 'Legal requirement?', placeholder: 'e.g. Landlord obligation, local authority' }],
  INSTALLATION: [{ label: 'Item to install *', placeholder: 'e.g. Worcester 30i combi boiler' }, { label: 'Scope of work', placeholder: 'Brief scope…' }],
  MAINTENANCE:  [{ label: 'System / asset', placeholder: 'e.g. Central heating system' }, { label: 'Last serviced', placeholder: 'e.g. 12 months ago' }],
  EMERGENCY:    [{ label: 'Fault description *', placeholder: 'Describe the emergency…' }, { label: 'Safety risk?', placeholder: 'e.g. Gas smell, no heat/hot water' }],
  OTHER:        [{ label: 'Description *', placeholder: 'Describe the work required…' }],
};

export default function JobDetailsStep2({ data, onDataChange }: StepProps) {
  const typeFields = TYPE_FIELDS[data.jobType] || TYPE_FIELDS['OTHER'];

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Job details</h3>
        <p className="step-form-subtitle">
          {data.jobType ? `Specific details for a ${data.jobType?.toLowerCase()} job.` : 'Fill in the job specifics.'}
        </p>
      </div>

      <div className="space-y-3">
        <div>
          <label className="block text-[11px] font-medium text-[#374151] mb-1">Job title *</label>
          <input
            type="text"
            placeholder="e.g. Annual boiler service — 14 Elm St"
            value={data.title || ''}
            onChange={e => onDataChange({ title: e.target.value })}
            className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1B1B1B]"
          />
        </div>

        {typeFields.map(({ label, placeholder }, i) => (
          <div key={i}>
            <label className="block text-[11px] font-medium text-[#374151] mb-1">{label}</label>
            <textarea
              placeholder={placeholder}
              rows={2}
              value={data[`typeField_${i}`] || ''}
              onChange={e => onDataChange({ [`typeField_${i}`]: e.target.value })}
              className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1B1B1B] resize-none"
            />
          </div>
        ))}

        <div>
          <label className="block text-[11px] font-medium text-[#374151] mb-1">Additional notes</label>
          <textarea
            placeholder="Access codes, special instructions, parking info…"
            rows={2}
            value={data.description || ''}
            onChange={e => onDataChange({ description: e.target.value })}
            className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1B1B1B] resize-none"
          />
        </div>

        <div>
          <label className="block text-[11px] font-medium text-[#374151] mb-1">Estimated duration</label>
          <select
            value={data.estimatedDuration || ''}
            onChange={e => onDataChange({ estimatedDuration: parseInt(e.target.value) })}
            className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1B1B1B]"
          >
            <option value="">Select…</option>
            <option value="30">30 minutes</option>
            <option value="60">1 hour</option>
            <option value="90">1.5 hours</option>
            <option value="120">2 hours</option>
            <option value="180">3 hours</option>
            <option value="240">Half day (4 hrs)</option>
            <option value="480">Full day (8 hrs)</option>
          </select>
        </div>
      </div>
    </div>
  );
}
